import { ca } from '@cian/analytics';

export function trackPanoramaShow(isFullscreen: boolean, objectType?: string) {
  ca('eventSite', {
    action: 'panorama',
    category: 'Infrastructure',
    label: isFullscreen ? 'show_sopr' : 'close_show_sopr',
    name: 'oldevent',
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        PageTypeJK: 'Featuring',
        object_type: objectType,
      },
    },
    useLastProducts: true,
  });
}
